export const actionStage = {
  addActionStage: 'Utwórz nowy etap',
  editActionStage: 'Edytuj etap',
  createdActionStage: 'Utworzono nowy etap',
  updatedActionStage: 'Zaktualizowano etap',
  updatedIndexActionStage: 'Zaktualizowano indeks etapu',
  assignedNode: 'Przypisano krok do etapu',
  manageActionStagesPara:
    'Edytuj, usuń, dodaj etapy i zarządzaj ich kolejnością. Etapy są używane do grupowania kroków w szablonie konfiguracji.',
  unassignedSteps: 'Nieprzypisane kroki',
  deleteStageActionTitle: 'Czy na pewno chcesz usunąć etap: { code }',
  deletedActionStageSuccess: 'Usunięto etap',
  tooltip: {
    edit: 'Edytuj',
    delete: 'Usuń',
    move: 'Przeciągnij aby zmienić kolejność',
  },
} as const
